import { useState } from 'react'
import config from 'config'
import { IDrawingSearchResponse } from 'models/SearchResponse'
import { SearchFilters } from './useSearchQueryAndFilters'
import { useAuth0Authentication } from './useAuth0Authentication'

export const useDrawings = () => {

    const [drawings, setDrawingSearchResponse] = useState<IDrawingSearchResponse>()
    const { getAuth0AccessToken } = useAuth0Authentication()

    const searchDrawingsApi = async (query: string, filters?: SearchFilters, page?: number): Promise<Response> => {

        const pageParam: string = page ? `&page=${page}` : ``
    
        const accessToken: string = await getAuth0AccessToken()
    
        if (filters) {
          const typeFilters: string = filters && filters.type && filters.type.appliedFilters.length > 0  ? `&type=${filters.type.appliedFilters.join(',')}` : ''
          const categoryFilters: string = filters && filters.category && filters.category.appliedFilters.length > 0  ? `&category=${filters.category.appliedFilters.join(',')}` : ''
    
          return fetch(
            `${config.apiUrl}/drawings/search?q=${query}${pageParam}${typeFilters}${categoryFilters}`
              , {
                method: 'GET',
                redirect: 'follow',
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                  "Content-Type": 'application/json'
              },
              }); 
        } else {
          return fetch(
            `${config.apiUrl}/drawings/search?q=${query}${pageParam}`
              , {
                method: 'GET',
                redirect: 'follow',
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                  "Content-Type": 'application/json'
              },
              }); 
        }
      }

      const searchDrawings = async (query: string, filters?: SearchFilters, page?: number) => {
 
        const response = await searchDrawingsApi(query, filters, page)
        const searchResp = await response.json()
        setDrawingSearchResponse(searchResp)
      }

    return {
        drawings,
        searchDrawings,
        searchDrawingsApi
    }
}